module.exports = __webpack_public_path__ + "static/media/search.62fd06d8.svg";